import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Login } from './components/Login';
import { Dashboard } from './core/dashboard/Dashboard';
import { dataProvider } from './dataProvider';
import { authProvider } from './authProvider';
import i18nProvider from './id18n';
import roles from '@core/roles';
import users from '@core/users';
import goods from '@core/goods';
import store from '@core/store';
import price from '@core/price';
import target from '@core/target';
import schedule from '@core/schedule';
import setting from '@core/setting';
import order from '@core/order';
import orderDetail from '@core/order-detail';
import PrivacyPolicy from '@components/PrivacyPolicy';
import { entityResource as ent } from './entityResource';
import { darkTheme, lightTheme } from './theme';

export const App = () => (
    <Admin
        authProvider={authProvider}
        dataProvider={dataProvider}
        dashboard={Dashboard}
        i18nProvider={i18nProvider}
        layout={Layout}
        loginPage={Login}
        defaultTheme="light"
        darkTheme={darkTheme}
        lightTheme={lightTheme}
    >
        <Resource name="goods" {...goods} recordRepresentation="name" />
        <Resource name="store" {...store} recordRepresentation="name" />
        <Resource name="price" {...price} recordRepresentation="name" />
        <Resource name="target" {...target} recordRepresentation="name" />
        <Resource name="schedule" {...schedule} recordRepresentation="name" />
        <Resource
            name="order"
            {...order}
            recordRepresentation={record => record.invoiceNo}
        />
        <Resource name="order-detail" {...orderDetail} />
        <Resource name="settings" {...setting} recordRepresentation="name" />
        <Resource name="roles" {...roles} recordRepresentation="name" />
        <Resource name="users" {...users} recordRepresentation="name" />
        <Resource
            name="order-detail"
            {...orderDetail}
            recordRepresentation="name"
        />
        <CustomRoutes>
            <Route path={ent.GOODS.UPLOAD_URL} element={<goods.upload />} />
            <Route path={ent.STORE.UPLOAD_URL} element={<store.upload />} />
            <Route path={ent.PRICE.UPLOAD_URL} element={<price.upload />} />
            <Route
                path={ent.SCHEDULE.GENERATE}
                element={<schedule.generate />}
            />
        </CustomRoutes>
        <CustomRoutes noLayout>
            <Route path={ent.PRIVACY_POLICY.NAME} element={<PrivacyPolicy />} />
        </CustomRoutes>
    </Admin>
);
